import React from "react";
import { useState, useEffect } from "react";
import { LuCalendarCheck } from "react-icons/lu";
import ReactTooltip from "react-tooltip";
import { Alert, Button, Col, Row, UncontrolledAlert } from "reactstrap";
import axios from "../../../../axios";
import {
  LayoutHeadingShadow,
  LayoutHeadingShadowLeft,
  LayoutRowShadow,
} from "../../../../components/TableComponents/RowCardShadow/RowCardShadow";
import { toastContainer } from "../../../../utils/toast";
import * as url from "../../../../utils/url";
import DaniContainer from "../../../dani/DaniContainer";
import DaniHeader from "../../../dani/DaniHeader";
import { LayoutData } from "../../../../components/TableComponents/RowCardShadow/RowCardShadow";
import moment from "moment";
import { Spinner } from "../../../../utils/constants";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import * as actionCreators from "../../../../modules/actions";
import parse from "react-html-parser"

import {
  BiCheckbox,
  BiCheckboxChecked,
  BiLinkExternal,
  BiX,
} from "react-icons/bi";
import { BsDash } from "react-icons/bs";
import TrivvyCreateSteps from "./LoaderBoxSteps";
import ViewSummaryCommon from "../../../../components/Trivvy/ViewSummarycomon";

function CreateTrivvyLoaderBox({
  loaderApiData,
  user,
  setGenerateSummaryLoader,
  generateSummaryLoader,
  ...props
}) {
  const [currentStep, setCurrentStep] = useState(1);
  const [summaryText, setSummaryText] = useState("");
  const [summaryGenerated,setsummaryGenerated] = useState(false)

  const [loadingSteps, setLoadingSteps] = useState([
    {
      stepNumber: 1,
      stepText: "Generating summary",
    },
    {
      stepNumber: 2,
      stepText: "",
    },
  ]);

  const renderContentHtmlGeneratingSummary = (content, contentType) => {
    if (content) {
      if (contentType == "TEXT") {
        return parse(`<div>Generating summary on "<span style={{wordBreak:"break-all"}}>${
          content.length > 50 ? `${content.slice(0, 50)}...` : content
        }</span>"</div>`);
      } else {
        return parse(`<div>Generating summary on <a href="${content}" style={{wordBreak:"break-all"}} target="_blank">${
          content.length > 50 ? `${content.slice(0, 50)}...` : content
        }</a></div>`);
      }
    } else {
      return "Generating summary on...";
    }
  };
  const renderContentHtmlViewSummary = (summaryText) => {
    return (
      <div>
        Summary generated succesfully.{" "}
        <ViewSummaryCommon
          summaryText={summaryText}
          btnUi={<b style={{textDecoration:"underline",cursor:"pointer"}}>View Summary</b>}
        />{" "}
      </div>
    );
  };

  const changeStepText = (index, newText) => {
    const stepsArr = [...loadingSteps];

    stepsArr[index].stepText = newText;

    setLoadingSteps(stepsArr);
  };

  useEffect(() => {
    if (loaderApiData) {
     
      setCurrentStep(1);
      const newPayload = {
        ...loaderApiData.payload,
      };

      changeStepText(
        0,
        renderContentHtmlGeneratingSummary(
          loaderApiData.content,
          loaderApiData.contentType
        )
      );

      axios
        .get(url.generateAndStoreSummaryForLibrarySource(loaderApiData._id))
        .then(({ data }) => {
          setsummaryGenerated(true)
          setCurrentStep(3);
          if(loaderApiData.cb){
            loaderApiData.cb(data.data)
          }
          changeStepText(
            1,
            renderContentHtmlViewSummary(data.data.summaryText)
          );
        })
        .catch((err) => {
          console.log(err);
          setGenerateSummaryLoader({
            minimize: true,
            display: false,
            loaderApiData: null,
          });
        });
    }
  }, []);

  return (
    <div className={summaryGenerated ? `summaryGenerated` : ""}>
      <DaniContainer
        height={480}
        width={450}
        opened={true}
        minimized={generateSummaryLoader.minimize}
        solid={true}
      >
        <DaniHeader
          summaryGenerated={summaryGenerated}
          style={{
            backgroundColor: summaryGenerated ? "#d4edda" : "",
          }}
        >
          <div
            className="text-center font-weight-bold"
            style={{ color: "black", width: "80%", fontSize: "1.1em" }}
          >
            {summaryGenerated ? (
              <span style={{ color: "#073d13 !important" }}>
                Completed <BiCheckboxChecked />{" "}
              </span>
            ) : (
              "Generating summary"
            )}
          </div>
          <div
            className="cursor-pointer ml-2"
            style={{ color: "black" }}
            onClick={() => {
              setGenerateSummaryLoader({
                ...generateSummaryLoader,
                minimize: !generateSummaryLoader.minimize,
              });
            }}
          >
            {generateSummaryLoader.minimize ? <BiLinkExternal /> : <BsDash />}
          </div>
          <div
            className="cursor-pointer ml-2"
            style={{ color: "black" }}
            onClick={() => {
              setGenerateSummaryLoader({
                display: false,
                loaderApiData: null,
                minimize: false,
              });
            }}
          >
            <BiX />
          </div>
        </DaniHeader>

        {!generateSummaryLoader.minimize ? (
          <div>
            <div>
              <TrivvyCreateSteps
                currentStep={currentStep}
                steps={loadingSteps}
              />
            </div>
          </div>
        ) : (
          ""
        )}
      </DaniContainer>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    generateSummaryLoader: state.trivia.generateSummaryLoader || {
      display: false,
    },
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setGenerateSummaryLoader: (data) =>
      dispatch(actionCreators.setGenerateSummaryLoader(data)),
    setImportTemplateAddedTrivvys: (data) =>
      dispatch(actionCreators.setImportTemplateAddedTrivvys(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CreateTrivvyLoaderBox, axios));
